const NETWORK_ERROR_PATTERNS = [
  'failed to fetch',
  'network request failed',
  'networkerror',
  'load failed',
  'timeout',
  'timed out',
];

const PERMISSION_ERROR_PATTERNS = [
  'not eligible to favourite',
  'product not found',
  'access denied',
  'forbidden',
  'insufficient',
];

/**
 * Maps favourite API errors to user-facing messages.
 * Returns null when auth interceptor already handled the session (no duplicate alert).
 */
export function getFavouriteErrorMessage(error: unknown): string | null {
  if (!(error instanceof Error)) {
    return 'Could not update favourites. Please try again.';
  }

  const normalizedMessage = error.message.trim().toLowerCase();

  if (normalizedMessage === 'authentication required') {
    return null;
  }

  if (NETWORK_ERROR_PATTERNS.some((pattern) => normalizedMessage.includes(pattern))) {
    return 'Network error. Check your connection and try again.';
  }

  if (PERMISSION_ERROR_PATTERNS.some((pattern) => normalizedMessage.includes(pattern))) {
    return 'You do not have permission to favourite this product.';
  }

  if (normalizedMessage.includes('favourite not found')) {
    return 'This product is not in your favourites.';
  }

  return error.message || 'Could not update favourites. Please try again.';
}
